// aramgah · agent · hook
// Empire-Self ambient tile. Disabled by default, opt-in via Settings.
// Source: chassis/src/agent/proactive-rules.ts (rhr.climb). DPDP scope: read.sleep.

export interface AgentHookInsight {
  readonly headline: string;
  readonly priority: 1 | 2 | 3;
}

export type AgentSnapshot = Record<string, unknown>;

const STORAGE_KEY = "aramgah-empire-self-enabled";
const APP_SLUG = "aramgah";
const SCOPE = "read.sleep";

export function isEnabled(): boolean {
  if (typeof localStorage === "undefined") return false;
  return localStorage.getItem(STORAGE_KEY) === "1";
}

export function setEnabled(v: boolean): void {
  if (typeof localStorage === "undefined") return;
  if (v) localStorage.setItem(STORAGE_KEY, "1");
  else localStorage.removeItem(STORAGE_KEY);
}

export function getMockSnapshot(): AgentSnapshot {
  return {"rhr_7d_delta": 4, "deep_sleep_min_delta": -18};
}

function evaluate(s: AgentSnapshot): AgentHookInsight | null { 
  const d = (s.rhr_7d_delta as number | undefined) ?? 0;
  const sd = (s.deep_sleep_min_delta as number | undefined) ?? 0;
  if (d < 3) return null;
  return {
    headline: `RHR climbed ${d}bpm over last 7 days; deep-sleep ${sd < 0 ? 'down' : 'up'} ${Math.abs(sd)} min`,
    priority: 2,
  };
}

const EM_DASH = /[—–]/;
const EMOJI = /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/u;

function toneOk(text: string): boolean {
  if (!text.trim()) return false;
  if (EM_DASH.test(text)) return false;
  if (EMOJI.test(text)) return false;
  return text.length <= 220;
}

export function renderTile(host: HTMLElement, snapshot: AgentSnapshot = getMockSnapshot()): void {
  host.innerHTML = "";
  if (!isEnabled()) return;
  const insight = evaluate(snapshot);
  if (!insight || !toneOk(insight.headline)) return;
  const wrap = document.createElement("aside");
  wrap.setAttribute("role", "status");
  wrap.setAttribute("aria-live", "polite");
  wrap.dataset.priority = String(insight.priority);
  wrap.dataset.app = APP_SLUG;
  wrap.dataset.scope = SCOPE;
  wrap.className = "empire-self-tile";
  const kicker = document.createElement("b");
  kicker.textContent = "empire-self";
  const body = document.createElement("p");
  body.textContent = insight.headline;
  wrap.append(kicker, body);
  host.append(wrap);
}

export function mountAmbient(): void {
  if (typeof document === "undefined") return;
  let host = document.getElementById("empire-self-tile");
  if (!host) {
    host = document.createElement("section");
    host.id = "empire-self-tile";
    host.dataset.app = APP_SLUG;
    document.body.prepend(host);
  }
  renderTile(host, getMockSnapshot());
}
